import React, { useEffect, useState } from "react";

import Nav from "../NavBar/Nav";
import FooterNew from "../NavBar/FooterNew";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import "./insurance.css";

import { useForm, useFieldArray, Controller } from "react-hook-form";
import Select from "react-select";
import { Country, State } from "country-state-city";
import { MdDeleteOutline } from "react-icons/md";
import axios from "axios";
import base_url from "../../api/bootapi";
import Swal from "sweetalert2";
import PlanItem from "./PlanItem";
import { FaLocationDot } from "react-icons/fa6";
import { MdDateRange } from "react-icons/md";
import { MdPeople } from "react-icons/md";
import { FaPen } from "react-icons/fa";
import { IoChevronBackOutline } from "react-icons/io5";

import moment from "moment";
import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";

const TravelInsurancePlans = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [travelInsuranceData, setTravelInsuranceData] = useState(() => {
    const saved = localStorage.getItem("quote");
    return saved ? JSON.parse(saved) : null;
  });
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem("formData");
    return saved ? JSON.parse(saved) : null;
  });

  console.log(formData)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChangeClick = () => {
    navigate("/insurance", { state: true });
  };

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Nav />

      {travelInsuranceData && (
        <div style={{ background: "#f8f8f8" }}>
          <div className="insurance-data-wrapper">
            <div className="insurance-plan-header">
              {/* <span
                className="insurance-back-btn"
                onClick={() => setTravelInsuranceData(null)}
              >
                <IoChevronBackOutline size={"23px"} />
              </span> */}
              <h1>Insurance Plans</h1>
            </div>
            <div className="traveler-info-wrapper">
              <div className="traveler-info">
                <span className="traveler-info-icon-wrapper">
                  <FaLocationDot size={"18px"} color="#757575" />
                </span>

                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Destinations</span>

                  <span className="traveler-info-data">
                    {formData?.destinations
                      ?.map((destination) => {
                        return (
                          destination.countryName
                        );
                      })
                      .join(",")}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <span className="traveler-info-icon-wrapper">
                  <MdDateRange size={"18px"} color="#757575" />
                </span>

                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Departure Date</span>

                  <span className="traveler-info-data">
                    {moment(formData?.departureDate).format("MM/DD/YYYY")}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <span className="traveler-info-icon-wrapper">
                  <MdDateRange size={"18px"} color="#757575" />
                </span>

                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Return Date</span>

                  <span className="traveler-info-data">
                    {moment(formData?.returnDate).format("MM/DD/YYYY")}
                  </span>
                </div>
              </div>

              <div className="traveler-info">
                <span className="traveler-info-icon-wrapper">
                  <MdPeople size={"18px"} color="#757575" />
                </span>

                <div className="traveler-info-title-wrapper">
                  <span className="traveler-info-title">Travelers Details</span>

                  <span className="traveler-info-data">
                    {formData?.additionalTravelers.length + 1}{" "}
                    {formData?.additionalTravelers.length === 0
                      ? " Traveler"
                      : " Travelers"}
                  </span>
                </div>
              </div>

              <button className="traveler-edit-btn" onClick={handleChangeClick}>
                <FaPen size={"14px"} />
                Change
              </button>
            </div>

            <div className="plans-wrapper">
              {travelInsuranceData.map((plan, index) => {
                return <PlanItem plan={plan} formData={formData} />;
              })}
            </div>
          </div>
        </div>
      )}

      <FooterNew />
    </div>
  );
};

export default TravelInsurancePlans;
